export default __webpack_public_path__ + "static/media/kitchen5-beforeD-1920w.0d210809.avif";